import { render, staticRenderFns } from "./_live-data.vue?vue&type=template&id=58d63148&scoped=true&"
import script from "./_live-data.vue?vue&type=script&lang=js&"
export * from "./_live-data.vue?vue&type=script&lang=js&"
import style0 from "./_live-data.vue?vue&type=style&index=0&id=58d63148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d63148",
  null
  
)

export default component.exports